import { useState} from "react";
import { useDispatch } from "react-redux";
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import FormInput from "../FormInput/FormInput";
import FormTextarea from "../FormTextarea/FormTextarea";
import styles from "./FeedbackModal.module.css";


export default function FeedbackModal() {
    const dispatch = useDispatch();
    const [buttonText, setButtonText] = useState("Send");

    const handleClose = function() {
        dispatch(uiActions.setFeedbackModalActive(false));
    } 

    const [formValidity, setFormValidity] = useState({});

    const checkFormValidity = () => {
        for (let key in formValidity) {
            if (!formValidity[key]) {
                document.getElementById(key).focus();
                document.getElementById(key).blur();
                return false;
            }
        }
        return true;
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        if(checkFormValidity()){
            setButtonText("Sending...");
            const data = new FormData(event.target);
            const dataObj = data.entries();
            const formData = {};
            dataObj.forEach((arry, key) => {
                formData[arry[0]] = arry[1]
            });
            console.log(formData);
            try {
                const response = await fetch('/services/feedback.ashx', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(formData),
                });

                if (response.ok) {
                    // Handle success
                    setButtonText("Feedback sent successfully!");
                    console.log('Form submitted successfully');
                    setTimeout(() => {
                        setButtonText("Send");
                        handleClose();
                    }, 2000); // Reset the button after 2 seconds
                } else {
                    // Handle error
                    setButtonText("Send");
                    console.error('Form submission failed');
                }
            } catch (error) {
                setButtonText("Send");
                console.error('Error submitting form:', error);
            }
        }
    };

    return (
        <>
        <PopUpModal handleClose={handleClose}>
            <div className={styles.container}>
                        <h2>Feedback</h2>
                        <p>Please send us any questions or comments you may have.</p>
                        <form onSubmit={handleSubmit}>
                            <FormInput
                                id="name"
                                label="Your Name"
                                type="text"
                                name="name"
                                defaultText=""
                                required={true}
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/.*/}
                                setFormValidity={setFormValidity}
                            />
                            <FormInput
                                id="fromEmail"
                                label="Email Address"
                                type="email"
                                name="fromEmail"
                                required={true}
                                errorMsg={"Enter valid email address. ex - someone@example.com"}
                                pattern={/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/}
                                setFormValidity={setFormValidity}
                            />
                            <FormTextarea
                                id="message"
                                label="Message"
                                name="message"
                                defaultText=""
                                required={true}
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/.*/}
                                setFormValidity={setFormValidity}
                            />
                            <button type="submit">{buttonText}</button>
                            <button type="button" className={styles.blueBack} onClick={handleClose}>Cancel</button>
                        </form>
                    </div>
        </PopUpModal>
        </>
    );
}
